"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_icons_1 = require("@carvana/helios-icons");
var helios_styles_1 = require("@carvana/helios-styles");
var test_attributes_1 = require("@carvana/test-attributes");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var useMediaQuery_1 = __importDefault(require("../useMediaQuery"));
var useWindowLoaded_1 = require("../useWindowLoaded");
var Banner_styles_1 = require("./Banner.styles");
var Banner = function (_a) {
    var className = _a.className, _b = _a.type, type = _b === void 0 ? 'system' : _b, layout = _a.layout, _c = _a.icon, icon = _c === void 0 ? false : _c, _d = _a.open, open = _d === void 0 ? false : _d, onDismiss = _a.onDismiss, children = _a.children, rest = __rest(_a, ["className", "type", "layout", "icon", "open", "onDismiss", "children"]);
    var isClient = (0, useWindowLoaded_1.useWindowLoaded)();
    var getTestAttributes = (0, test_attributes_1.useTestFunc)();
    var isViewportDesktop = (0, useMediaQuery_1.default)("(min-width: ".concat(helios_styles_1.breakpoint.md, ")"));
    var isViewportMobile = (0, useMediaQuery_1.default)("(max-width: ".concat(helios_styles_1.breakpoint.sm, ")"));
    var activeLayout = (0, react_1.useMemo)(function () {
        if (layout)
            return layout;
        if (isViewportMobile) {
            return 'mobile';
        }
        if (isViewportDesktop) {
            return 'desktop';
        }
        return 'tablet';
    }, [isViewportMobile, isViewportDesktop]);
    var bannerIcon = (0, react_1.useMemo)(function () {
        if (icon && typeof icon !== 'boolean')
            return icon;
        switch (type) {
            case 'warning':
                return (0, jsx_runtime_1.jsx)(helios_icons_1.QuestionCircle, {});
            case 'success':
                return (0, jsx_runtime_1.jsx)(helios_icons_1.CheckmarkCircle, {});
            case 'critical':
            default:
                return (0, jsx_runtime_1.jsx)(helios_icons_1.ExclamationCircle, {});
        }
    }, [icon, type]);
    var dismissible = onDismiss && typeof onDismiss === 'function';
    return (isClient && open) &&
        (0, jsx_runtime_1.jsx)(Banner_styles_1.Container, __assign({ className: (0, classnames_1.default)(className, "banner--".concat(type)), type: type, layout: activeLayout }, getTestAttributes('banner'), { "data-testid": "banner" }, rest, { children: (0, jsx_runtime_1.jsxs)(Banner_styles_1.Content, { children: [activeLayout === 'desktop' && (0, jsx_runtime_1.jsx)(Banner_styles_1.Space, {}), activeLayout === 'mobile'
                        ? (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [icon && (0, jsx_runtime_1.jsx)(Banner_styles_1.Icon, { children: bannerIcon }), (0, jsx_runtime_1.jsx)(Banner_styles_1.MessageContainer, { children: children })] })
                        : (0, jsx_runtime_1.jsxs)(Banner_styles_1.MessageContainer, { children: [icon && (0, jsx_runtime_1.jsx)(Banner_styles_1.Icon, { children: bannerIcon }), children] }), dismissible ? ((0, jsx_runtime_1.jsx)(Banner_styles_1.CloseButton, __assign({ className: "banner--close-button", onClick: onDismiss, "aria-label": "Close", "data-testid": "close-button" }, { children: (0, jsx_runtime_1.jsx)(helios_icons_1.XIcon, {}) }))) : (0, jsx_runtime_1.jsx)(Banner_styles_1.Space, {})] }) }));
};
exports.Banner = Banner;
exports.Banner.Headline = Banner_styles_1.Headline;
exports.Banner.Message = Banner_styles_1.Message;
exports.Banner.Button = Banner_styles_1.ActionButton;
exports.Banner.Link = Banner_styles_1.ActionLink;
